import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ImageTextCard from "@components/WebsiteRevamp/ImageTextCard/ImageTextCard"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./SocialResponsibilityBuildingSection.module.scss"

type Props = {data: AdvancedSideAssetModuleType}

const SocialResponsibilityBuildingSection = (props: Props) => {
	const data = props.data.mainContent
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Separator />

					<div className={styles.cardContainer}>
						{data?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										className={styles.cardBox}
										contentProps={{
											data: element,
											titleProps: {
												size: Size.S,
												style: {
													marginTop: "1rem",
													paddingBottom: "0rem",
												},
											},
										}}
										contentContainer={
											styles.contentContainer
										}
										imageProps={{
											imageClassName: `${styles.imageClassName}`,
											containerClassName: `${styles.imageContainer}`,
										}}
									/>
								)
							},
						)}
					</div>

					{/* {data && (
						<ContentAssetSwitcher
							contentAssetProps={{
								data,
								withAspectRation: true,
								contentProps: {
									titleProps: {
										fontWeight: 300,
										stripHtml: false,
									},
								},
							}}
							data={props.data}
							separatorSize={128}
						/>
					)} */}
				</ContainerWrapper>
			</Separator>
		</section>
	)
}

export default SocialResponsibilityBuildingSection
